import { createElement } from "react";
import { CircleCheck, Info, TriangleAlert } from "lucide-react";
import { toast, Slide } from "react-toastify";

const TOAST_PRESENTATION = {
  success: { Icon: CircleCheck },
  info: { Icon: Info },
  warning: { Icon: TriangleAlert },
  error: { Icon: TriangleAlert },
};

const createDefaultIcon = (Icon) =>
  createElement(
    "span",
    { className: "dm-toast__icon", "aria-hidden": true },
    createElement(Icon, { size: 18, strokeWidth: 2.1 }),
  );

/**
 * @param {string} message
 * @param {'info' | 'success' | 'error' | 'warning'} [type]
 * @param {{
 *   toastId?: string,
 *   icon?: false | import('react').ReactNode,
 *   actionLabel?: string,
 *   actionHref?: string,
 *   autoClose?: number | false,
 * }} [options]
 */
export const showToast = (message, type = "info", options = {}) => {
  console.log("[TOAST] showToast called:", {
    message,
    type,
    options,
    timestamp: new Date().toISOString(),
  });

  const {
    toastId,
    icon,
    actionLabel,
    actionHref,
    autoClose = 10000,
  } = options;

  try {
    const normalizedType = TOAST_PRESENTATION[type] ? type : "info";
    const { Icon } = TOAST_PRESENTATION[normalizedType];
    const createContent = (closeToast) =>
      createElement(
        "div",
        { className: "dm-toast__content" },
        createElement("p", { className: "dm-toast__message" }, message),
        actionLabel && actionHref
          ? createElement(
              "button",
              {
                type: "button",
                className: "dm-toast__action",
                onClick: () => {
                  window.location.href = actionHref;
                  closeToast?.();
                },
              },
              actionLabel,
            )
          : null,
      );
    const content = actionLabel && actionHref
      ? ({ closeToast }) => createContent(closeToast)
      : createContent();

    const toastFn = toast[normalizedType];
    const toastOpts = {
      position: "top-right",
      autoClose,
      hideProgressBar: false,
      closeOnClick: !(actionLabel && actionHref),
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Slide,
      className: `dm-toast dm-toast--${normalizedType}`,
      progressClassName: "dm-toast__progress",
      ...(toastId ? { toastId } : {}),
      ...(icon === false
        ? { icon: false }
        : { icon: icon != null ? icon : createDefaultIcon(Icon) }),
    };

    const id = toastFn(content, toastOpts);
    console.log("[TOAST] Toast created with ID:", id);
  } catch (error) {
    console.error("[TOAST] Error showing toast:", error);
  }
};
